export default __webpack_public_path__ + "static/media/HISTORY_GEOGRAPHY.5e9a1462.svg";